import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row m-4 mt-0" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card card-body mb-0 text-center text-muted py-3" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = { class: "card card-body mb-0" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "form-group col-sm-12" }
const _hoisted_11 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticSummary = _resolveComponent("StatisticSummary")!
  const _component_StatisticTurnoverSummary = _resolveComponent("StatisticTurnoverSummary")!
  const _component_StatisticOnline = _resolveComponent("StatisticOnline")!
  const _component_StatisticRequisites = _resolveComponent("StatisticRequisites")!
  const _component_StatisticLabelsOperations = _resolveComponent("StatisticLabelsOperations")!
  const _component_StatisticTraders = _resolveComponent("StatisticTraders")!
  const _component_StatisticDetailedAmounts = _resolveComponent("StatisticDetailedAmounts")!
  const _component_StatisticPartnersIncomes = _resolveComponent("StatisticPartnersIncomes")!
  const _component_StatisticProviderRequests = _resolveComponent("StatisticProviderRequests")!
  const _component_StatisticIssuanceTime = _resolveComponent("StatisticIssuanceTime")!
  const _component_StatisticConversion = _resolveComponent("StatisticConversion")!
  const _component_StatisticCascadeRating = _resolveComponent("StatisticCascadeRating")!
  const _component_StatisticSupportActivity = _resolveComponent("StatisticSupportActivity")!
  const _component_StatisticDashboardPlus = _resolveComponent("StatisticDashboardPlus")!
  const _component_StatisticReceiptChecks = _resolveComponent("StatisticReceiptChecks")!
  const _component_StatisticCounterparties = _resolveComponent("StatisticCounterparties")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isTeamLead && _ctx.isDashboardPlusDenied)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.helper.trans('statistic.dashboardPlus.access_denied')), 1)
            ])
          ])
        ]))
      : (_ctx.showTabs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("ul", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTabs, (tab) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: tab,
                            class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                          }, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.selectTab(tab)), ["prevent"]),
                              class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTabName === tab}])
                            }, _toDisplayString(_ctx.helper.trans(`statistic.tab.${tab}`)), 11, _hoisted_12)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.activeTabName === _ctx.Tabs.summary && _ctx.canShowSummary)
                ? (_openBlock(), _createBlock(_component_StatisticSummary, { key: 0 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.turnoverSummary && _ctx.canShowTurnoverSummary)
                ? (_openBlock(), _createBlock(_component_StatisticTurnoverSummary, { key: 1 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.online)
                ? (_openBlock(), _createBlock(_component_StatisticOnline, { key: 2 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.requisites)
                ? (_openBlock(), _createBlock(_component_StatisticRequisites, { key: 3 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.labelsOperation && _ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_StatisticLabelsOperations, { key: 4 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.traders && _ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_StatisticTraders, { key: 5 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.detailedAmounts)
                ? (_openBlock(), _createBlock(_component_StatisticDetailedAmounts, { key: 6 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.partnersIncomes)
                ? (_openBlock(), _createBlock(_component_StatisticPartnersIncomes, { key: 7 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.providerRequests)
                ? (_openBlock(), _createBlock(_component_StatisticProviderRequests, { key: 8 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.issuanceTime)
                ? (_openBlock(), _createBlock(_component_StatisticIssuanceTime, { key: 9 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.conversion)
                ? (_openBlock(), _createBlock(_component_StatisticConversion, { key: 10 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.cascadeRating && _ctx.canShowCascadeRating)
                ? (_openBlock(), _createBlock(_component_StatisticCascadeRating, { key: 11 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.supportActivity)
                ? (_openBlock(), _createBlock(_component_StatisticSupportActivity, { key: 12 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.dashboardPlus && _ctx.canShowDashboardPlus)
                ? (_openBlock(), _createBlock(_component_StatisticDashboardPlus, { key: 13 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.receiptChecks && _ctx.canShowReceiptChecks)
                ? (_openBlock(), _createBlock(_component_StatisticReceiptChecks, { key: 14 }))
                : _createCommentVNode("", true),
              (_ctx.activeTabName === _ctx.Tabs.counterparties && _ctx.canShowCounterparties)
                ? (_openBlock(), _createBlock(_component_StatisticCounterparties, { key: 15 }))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createBlock(_component_StatisticSummary, { key: 2 }))
  ]))
}